/*

    SUMMARY
        0 - FUNCTION
        1 - AJUST HEADER BACKGROUND



*/

export default function headers() {

    /*=================/ 0 - FUNCTION /=================*/

    /*=================/ 1 - AJUST HEADER BACKGROUND /=================*/
    window.addEventListener('scroll', () => {
        const pageY = window.scrollY;
        if (window.screen.width > 799) {
            if (pageY > 200) {
                gsap.to('#header', {
                    height: 150,
                    duration: 1,
                })
            } else {
                gsap.to('#header', {
                    height: 324,
                    duration: 1,
                })
            }
        }
    })

}